import {BasicBitmapCountUp} from "../countUp/BasicBitmapCountUp";
import {IMentalGameData} from "../../server/MentalData";
import {Mental} from "../../Mental";
import {TimelineLite, TweenLite} from "gsap";
import {SoundManager} from "../../sound/SoundManager";
import {MentalSoundConfig} from "../../MentalSoundConfig";
import {WinRatioType} from "../../../framework/winPresentation/IWinRatios";
import {MentalHelper} from "../../utils/MentalHelper";

export class MentalInitialWinPresentation extends PIXI.Container {
    private _countup: BasicBitmapCountUp
    private _gameData: IMentalGameData;

    constructor() {
        super();
        this.init();
    }

    public checkForPresentation(): boolean {
        if (Mental.model.gameData.betWayWins.length) {
            this._gameData = Mental.model.gameData;
            return true;
        }
        return false;
    }

    public startPresentation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        // #417
        tl.add(Mental.winWays.showInitialWinWays());

        if (this._gameData.isBigWin) {
            return tl;
        }

        const time: number = this._gameData.currentWinRatioConfig.duration,
            winType: WinRatioType | undefined = this._gameData.currentWinRatioConfig.type;

        tl.add(() => {
            this._countup.setText("");

            this._countup.visible = !MentalHelper.isSingleWinBelowStake(); // #420
            this._countup.alpha = 1;

            if (winType && (winType === WinRatioType.SMALL || winType === WinRatioType.MEDIUM || winType === WinRatioType.LARGE)) {
                Mental.background.playWinFlickerAnim(winType, 0);
            }

            // #138
            if (time > 0.001) {
                SoundManager.playSoundEffect(MentalSoundConfig.COUNT_UP, Infinity);
            }
        });

        tl.add(this._countup.getCountAnimation(0, this._gameData.totalBetWayWinnings, time));
        tl.add(() => {
            if (!MentalHelper.isSingleWinBelowStake()) {
                Mental.winWays.showTotalWinWaysItems(false);
            }

            // #138
            this.playCountUpEndSound();
        });
        tl.add(TweenLite.to(this, {duration: 1}));
        tl.add(() => {
            this.endPresentation();
        });
        return tl;
    }

    private init(): void {
        this._countup = new BasicBitmapCountUp({
            fontName: "MentalNumbersWinCountUp",
            fontSize: 32,
            tint: 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this._countup.position.set(360, 360);
        this._countup.visible = false;
        this.addChild(this._countup);
    }

    private endPresentation(): void {
        Mental.winWays.hideTotalWinWaysItems(0.5);

        TweenLite.to(this._countup, {duration: 0.5, alpha: 0}).eventCallback("onComplete", () => {
            this._countup.visible = false;
        });
    }

    // #138
    private playCountUpEndSound(): void {
        SoundManager.stopSoundEffect(MentalSoundConfig.COUNT_UP);

        // #146, #332
        SoundManager.fadeSound(MentalSoundConfig.INIT_WIN, 1, 0, 0.3);

        switch (this._gameData.currentWinRatioConfig.type) {
            case WinRatioType.TINY:
                if (!MentalHelper.isSingleWinBelowStake()) {
                    SoundManager.playSoundEffect(MentalSoundConfig.COUNT_UP_ENDS_TINY);
                }
                break;
            case WinRatioType.SMALL:
                SoundManager.playSoundEffect(MentalSoundConfig.COUNT_UP_ENDS_SMALL);
                break;
            case WinRatioType.MEDIUM:
                SoundManager.playSoundEffect(MentalSoundConfig.COUNT_UP_ENDS_MEDIUM);
                break;
            case WinRatioType.LARGE:
                SoundManager.playSoundEffect(MentalSoundConfig.COUNT_UP_ENDS_LARGE);
                break;
        }
    }
}